var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"status text-sm font-medium rounded-full tracking-wide inline-block",style:({'color': _vm.status.color})},[_vm._v(_vm._s(_vm.status.name))])}
var staticRenderFns = []

export { render, staticRenderFns }